import React from "react";
import { useTranslation } from "react-i18next";
import AnimatedDialog from "../AnimatedDialog/AnimatedDialog";

export interface CashoutDisableProps {
    readonly sendBackAction: () => void;
}

// tslint:disable-next-line:no-var-requires
const styles = require("./CashoutError.scss");

export function CashoutError({ sendBackAction }: CashoutDisableProps) {
    const { t } = useTranslation("cashout");
    return (
        <AnimatedDialog visible={true} title={t("CashoutBlocked")}>
            <div className={styles.message}> {t("CashoutBlocked")}</div>
            <button className={styles.btn} onClick={sendBackAction}>
                {t("OK")}
            </button>
        </AnimatedDialog>
    );
}
